import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PunchClockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"punch_clock"}/>
}
